import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Components
import { Col, List, Row, Form, Flex, message } from "antd";
import { CustomImage, CustomInput, CustomTitle, CustomButton } from "../../components";
import { LinkSensorsAccount } from "../../api's/onboarding";
import { useToken } from "../../common/helper";
import { useSpin } from "../../components/SpinContext";

// Assets
import sensorScreenshot from "../../assets/images/sensor-screenshot.png";

const ConnectsSensors = ({ closeModal, id, onSuccess, sensorData }) => {
  const [form] = Form.useForm();
  const [isFormValid, setIsFormValid] = useState(false);
  const { token, removeToken } = useToken();
  const { showSpin, hideSpin } = useSpin();
  const navigate = useNavigate();
  const [sensorModalInputs, setSensorModalInputs] = useState([]);

  useEffect(() => {
    if (sensorData?.required_inputs && Array.isArray(sensorData.required_inputs)) {
      setSensorModalInputs(sensorData.required_inputs);
    } else {
      setSensorModalInputs([]);
    }
    form.resetFields();
  }, [sensorData, form]);

  const description = sensorData?.description || [];

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  }

  const handleCancel = () => {
    closeModal();
  }

  const LinkSensors = (model) => {
    setIsFormValid(true);
    showSpin()
    LinkSensorsAccount(token, model)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data?.data?.is_success) {
            onSuccess();
            message.success(data?.data?.message);
            closeModal();
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((err) => {
        unauthorize(err)
      }).finally(() => {
        hideSpin();
        setIsFormValid(false);
      });
  }

  const onFinishForm = (values) => {
    if (values && Object.keys(values).length > 0 && id) {
      let model = {
        sensor_id: id,
        credentials: { ...values }
      };
      LinkSensors(model);
    }
  };

  const initialFormValues = sensorModalInputs.reduce((acc, inputName) => {
    acc[inputName] = '';
    return acc;
  }, {});

  return (
    <Form
      form={form}
      name="validateOnly"
      initialValues={initialFormValues}
      layout="vertical"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 24 }}
      autoComplete="off"
      onFinish={onFinishForm}
    >
      <Row gutter={12}>
        <Col span={24}>
          <div className="sensor-info">
            <div style={{ paddingLeft: "6px" }}>
              <CustomTitle
                text="Instructions"
                fontSize="14px"
                fontWeight="500"
                color="black"
              />
              <List
                split={false}
                itemLayout="horizontal"
                dataSource={description}
                renderItem={(item, index) => (
                  <List.Item style={{ padding: "0" }}>
                    <List.Item.Meta
                      title={
                        item.isLink ? (
                          <>
                            <span style={{ fontWeight: 400 }}>
                              {index + 1}. {item.title}{" "}
                            </span>
                            <a
                              href={item?.href}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "underline",
                                fontWeight: 400,
                              }}
                            >
                              {item.linkText}
                            </a>
                          </>
                        ) : (
                          <span style={{ fontWeight: 400 }}>
                            {index + 1}. {item?.title}
                          </span>
                        )
                      }
                    />
                  </List.Item>
                )}
              />
            </div>
            <Col span={12} style={{ marginTop: '20px' }}>
              {sensorModalInputs.map((element) => (
                <Form.Item
                  key={element}
                  label={element}
                  name={element}
                  style={{ paddingTop: "12px"}}
                  labelCol={{ width: "100%" }}
                  rules={[
                    {
                      required: true,
                      message: `Please input ${element}`,
                    },
                  ]}
                >
                  <CustomInput
                    placeholder={`Paste ${element} here`}
                    height="36px"
                    width="100%"
                    border="0px"
                    bgColor="#F3F3F3"
                    textColor="#5E5E5E"
                    borderRadius="8px"
                    placeholderColor="#5E5E5E"
                    lineHeight="38px"
                  />
                </Form.Item>
              ))}
            </Col>
          </div>
        </Col>
      </Row>
      <Flex justify="flex-end" gap={12} style={{ marginTop: 24 }}>
        <CustomButton
          key="cancel"
          onClick={handleCancel}
          text={"Cancel"}
          bgColor={"transparent"}
          color={"black"}
          height="40px"
          borderRadius="8px"
          border="1px solid #E6E6E6"
        />
        <Form.Item shouldUpdate noStyle>
          {() => (
            <CustomButton
              key="submit"
              onClick={() => form.submit()}
              text={"Link Account"}
              height="40px"
              bgColor={"#000"}
              color={"#fff"}
              borderRadius="8px"
              disabled={!form.isFieldsTouched(true) || !!form.getFieldsError().filter(({ errors }) => errors.length).length || isFormValid}
            />
          )}
        </Form.Item>
      </Flex>
    </Form>
  );
};

export default ConnectsSensors;
